/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   constants.ts
 */

import { AIRBNB_FRIENDLY_LABEL } from '../../../../constants'

export const POPULAR_AMENITY_OPTIMIZELY_EXPERIMENT = 'POPULAR_AMENITY_FILTERS'
export const POPULAR_AMENITY_OPTIMIZELY_VARIATION_ON = 'ON'
export const POPULAR_AMENITY_OPTIMIZELY_VARIATION_OFF = 'OFF'

export const POPULAR_AMENITY_TRAKTOR_KEY = 'POPULAR_FILTERS_LTR'
export const POPULAR_AMENITY_TRAKTOR_FILTER_APPLIED = 'Filter applied'
export const POPULAR_AMENITY_TRAKTOR_RESULTS_SHOWN = 'Results shown'

export const IN_UNIT_LAUNDRY = 'In unit laundry' as const
export const DISHWASHER = 'Dishwasher' as const
export const AIR_CONDITIONING = 'A/C' as const
export const GARAGE_PARKING = 'Garage parking' as const
export const HIGHEST_RATED = 'Highest rated'
export const AVAILABLE_NOW = 'Available now' as const
export const NO_FEE = 'No fee' as const
export const NEW_CONSTRUCTION = 'New construction' as const

export const popularAmenitiesVals = {
  [IN_UNIT_LAUNDRY]: {
    label: IN_UNIT_LAUNDRY,
    value: IN_UNIT_LAUNDRY,
  },
  [DISHWASHER]: {
    label: DISHWASHER,
    value: DISHWASHER,
  },
  [AIR_CONDITIONING]: {
    label: AIR_CONDITIONING,
    value: AIR_CONDITIONING,
  },
  [GARAGE_PARKING]: {
    label: GARAGE_PARKING,
    value: GARAGE_PARKING,
  },
  [HIGHEST_RATED]: {
    label: HIGHEST_RATED,
    value: HIGHEST_RATED,
  },
  [AVAILABLE_NOW]: {
    label: AVAILABLE_NOW,
    value: AVAILABLE_NOW,
  },
  [NO_FEE]: {
    label: NO_FEE,
    value: NO_FEE,
  },
  [AIRBNB_FRIENDLY_LABEL]: {
    label: AIRBNB_FRIENDLY_LABEL,
    value: AIRBNB_FRIENDLY_LABEL,
  },
  [NEW_CONSTRUCTION]: {
    label: NEW_CONSTRUCTION,
    value: NEW_CONSTRUCTION,
  },
} as const
